// src/apiConstants.js

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.thirdwavemicrocare.com/api'; //https://api.thirdwavemicrocare.com/api // http://localhost:3001/api

export const API_LOGIN = `${API_BASE_URL}/login-school`;

// // Define the endpoints for different API calls

export const API_ADD_STUDENT = `${API_BASE_URL}/add-student`;
export const API_UPDATE_STUDENT = `${API_BASE_URL}/update-student`;
export const API_GET_STUDENTS = `${API_BASE_URL}/students`;
export const API_STATUS_UPDATE = `${API_BASE_URL}/update-status`;

export const API_ADD_FEE = `${API_BASE_URL}/add-fee`;
export const API_UPDATE_FEE = `${API_BASE_URL}/update-fee`;
export const API_GET_FEES = `${API_BASE_URL}/fees`;

export const API_ADD_MISC_FEE = `${API_BASE_URL}/add-misc-fee`;
export const API_UPDATE_MISC_FEE = `${API_BASE_URL}/update-misc-fee`;

export const API_GET_MISC_FEES = `${API_BASE_URL}/misc-fees`;
export const API_GET_UNIFORM_PRICE_LIST = `${API_BASE_URL}/uniform-price-list`;

export const API_STUDENT_FEE_REPORTS = `${API_BASE_URL}/get-fees-report`;
export const API_MISC_FEE_REPORTS = `${API_BASE_URL}/get-misc-fees-report`;

export const API_ADD_CLASS_FEE_BOOK_PRICE = `${API_BASE_URL}/add-fee-book-master`;
export const API_GET_FEES_BOOKS_MASTER = `${API_BASE_URL}/get-fee-book-master`;



